import styled from "styled-components";

const SubHeading = styled.p`
  font-size: 18px;
  color: ${(props) => props.color || "var(--font1)"};
  margin: ${(props) => props.margin || 0};
  text-align: center;
  max-width: ${(props) => props.width};
`;

export default SubHeading;
